import { render, staticRenderFns } from "./teacherFeatured.vue?vue&type=template&id=6371e639&scoped=true&"
import script from "./teacherFeatured.js?vue&type=script&lang=js&"
export * from "./teacherFeatured.js?vue&type=script&lang=js&"
import style0 from "./teacherFeatured.vue?vue&type=style&index=0&id=6371e639&prod&lang=scss&"
import style1 from "./teacherFeatured.vue?vue&type=style&index=1&id=6371e639&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371e639",
  null
  
)

export default component.exports